import { z } from 'zod';

// Zero-fallback (mesma doutrina da app lean): variável obrigatória em falta faz
// a consola falhar ruidosamente no arranque, nunca degradar em silêncio.
const schema = z.object({
  VITE_API_ORIGIN: z.string().url(),
  VITE_CLERK_PUBLISHABLE_KEY: z.string().min(1),
  // OSS embutido (opcional): sem URL, o ecrã mostra "não configurado" em vez de
  // um iframe partido. Ligam-se quando o Metabase/Chatwoot estiverem no ar.
  VITE_METABASE_URL: z.string().url().optional().or(z.literal('')),
  VITE_CHATWOOT_URL: z.string().url().optional().or(z.literal('')),
  // ── Harness de QA visual (MESMA convenção da app lean) ──────────────────────
  // A consola só abre com sessão Clerk real + `/access/me` a devolver isStaff.
  // Isso é correto em produção e impossível em QA: nenhuma das ferramentas que
  // auditam o design (fotografia dos ecrãs, sonda de alvos, varrimento de
  // tipos) conseguia sequer chegar a uma página. Em preview, a consola arranca
  // com dados de amostra e sem gate — e NUNCA em produção: o ramo está atrás
  // desta variável, que o build de produção não define.
  VITE_PREVIEW: z.enum(['true', 'false']).default('false'),
});

const parsed = schema.safeParse(import.meta.env);
if (!parsed.success) {
  throw new Error(
    `[env] Configuração inválida:\n${parsed.error.issues
      .map((i) => `  • ${i.path.join('.')}: ${i.message}`)
      .join('\n')}\nCopie .env.example → .env.local e preencha.`,
  );
}

export const env = {
  apiOrigin: parsed.data.VITE_API_ORIGIN,
  clerkPublishableKey: parsed.data.VITE_CLERK_PUBLISHABLE_KEY,
  metabaseUrl: parsed.data.VITE_METABASE_URL || '',
  chatwootUrl: parsed.data.VITE_CHATWOOT_URL || '',
  preview: parsed.data.VITE_PREVIEW === 'true',
} as const;
